 <template>
    <el-dialog :visible.sync="visible" width="350px" append-to-body title="转交工单" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
        <el-form :model="form" size="mini" label-position="top" v-loading="loading">
            <el-form-item label="收单人" :rules="[{ required: true, message: '请选择收单人' }]" prop="user_receive_id">
                <users-select v-model="form.user_receive_id" />
            </el-form-item>
            <el-form-item label="协同人">
                <users-select v-model="form.user_assist_id" multiple />
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data () {
        return {
                        visible: false,
            loading: false,
            formError: {},
            form: {
                id: null,
                user_receive_id: null,
                user_assist_id: null
            }
        }
    },
    methods: {
        Open (id) {
            this.visible = true
            this.form.id = id
        },
        Close() {
            this.loading = false
            this.visible = false
        },
        SubmitForm() {
                        this.loading = true
            this.formError = {}
                        this.$http.post('/9api/pm/wo/update-relay', this.form).then(rps => {
                                this.loading = false
                this.$emit('onChange')
                this.Close()
            })
        }
    }  
}
</script>